module.exports = __webpack_public_path__ + "img/bg-bubbles.581517c8.png";